export const allNodes = [
  {
    "id": 1,
    "label": "AI",
    "shortLabel": "AI",
    "level": 0,
    "category": "Foundational Concepts",
    "definition": "The scientific and engineering discipline focused on creating machines and systems that perceive, reason, learn, and act in ways commonly associated with human intelligence.",
    "mars_cpg_example": "Developing a global strategy for using AI to optimize everything from cocoa sourcing to marketing campaigns.",
    "mars_wrigley_example": "Coordinating an AI program that links cocoa sourcing forecasts for Galaxy with dynamic shelf optimization for M&M's across global retailers."
  },
  {
    "id": 2,
    "label": "AI Core Concepts",
    "shortLabel": "AI Core Concepts",
    "level": 1,
    "category": "Foundational Concepts",
    "definition": "Core concepts, paradigms, and foundational methodologies that form the basis of AI.",
    "mars_cpg_example": "Understanding the basic building blocks of AI before implementing any AI solution across the organization.",
    "mars_wrigley_example": "Upskilling brand teams on ML basics so Snickers marketing can safely pilot personalization models."
  },
  {
    "id": 3,
    "label": "Symbolic AI",
    "shortLabel": "Symbolic AI",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Logic- and rule-based techniques that represent knowledge explicitly and perform reasoning using symbolic structures (logic, ontologies, production rules).",
    "mars_cpg_example": "A rule-based system that automatically flags a production line for maintenance if a sensor reading exceeds a pre-defined safety limit.",
    "mars_wrigley_example": "A rules engine that halts a Twix packaging line if a temperature sensor crosses a safety threshold."
  },
  {
    "id": 4,
    "label": "Machine Learning",
    "shortLabel": "Machine Learning",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Data-driven algorithms and statistical techniques that allow systems to improve performance on tasks from data rather than explicit rules.",
    "mars_cpg_example": "A model that learns the relationship between weather patterns and ice cream sales to predict demand for products.",
    "mars_wrigley_example": "Learning patterns between weekend footfall and Skittles sales to improve store replenishment."
  },
  {
    "id": 5,
    "label": "Supervised Learning",
    "shortLabel": "Supervised Learning",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Learning paradigms where models are trained on input–output pairs (labeled data) to predict outputs for new inputs.",
    "mars_cpg_example": "Teaching the computer with examples - like showing past sales numbers so it can guess how much chocolate people might buy next month.",
    "mars_wrigley_example": "Training a classifier to predict if an Orbit gum pack is misprinted using labeled camera images."
  },
  {
    "id": 6,
    "label": "Unsupervised Learning",
    "shortLabel": "Unsupervised Learning",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Learning paradigms that discover structure, patterns, or latent representations from unlabeled data.",
    "mars_cpg_example": "Letting the computer read thousands of reviews to figure out what people are talking about most - without being told what to look for.",
    "mars_wrigley_example": "Clustering millions of Starburst reviews to discover hidden themes like 'chewy texture' vs 'flavor burst'."
  },
  {
    "id": 7,
    "label": "Reinforcement Learning",
    "shortLabel": "Reinforcement Learning",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Learning paradigm where an agent learns to choose actions by interacting with an environment to maximize cumulative reward.",
    "mars_cpg_example": "Like teaching a computer to find the best price for snacks by trying different prices and seeing which one sells the most.",
    "mars_wrigley_example": "Tuning vending machine pricing for M&M's with an agent that tests prices by time and location."
  },
  {
    "id": 8,
    "label": "Self Supervised learning",
    "shortLabel": "Self Supervised learning",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "A form of unsupervised or pretraining approach where models create their own supervision signals (e.g., masked prediction, contrastive objectives) from raw data.",
    "mars_cpg_example": "Training a model to understand product descriptions by predicting masked words in marketing text, eliminating the need for manual labeling.",
    "mars_wrigley_example": "Pretraining on internal packaging copy to teach a model Mars Wrigley brand tone before fine-tuning."
  },
  {
    "id": 9,
    "label": "Semi-Supervised Learning",
    "shortLabel": "Semi Supervised Learning",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Techniques that combine small amounts of labeled data with large amounts of unlabeled data to improve learning efficiency and generalization.",
    "mars_cpg_example": "Improving a defect detection model by training it on a few thousand labeled images of good/bad packages and millions of unlabeled images.",
    "mars_wrigley_example": "Boosting defect detection on Milky Way wrappers using a few labeled faults plus a large pool of unlabeled images."
  },
  {
    "id": 10,
    "label": "Neural Networks",
    "shortLabel": "Neural Networks",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Parameterized function approximators composed of interconnected units (neurons) organized in layers; a foundational technique used across deep learning models.",
    "mars_cpg_example": "Using a neural network to predict consumer demand based on historical sales, promotions, and seasonal events.",
    "mars_wrigley_example": "A neural net that forecasts Extra gum demand from promotions, weather, and store traffic."
  },
  {
    "id": 11,
    "label": "Search & Planning",
    "shortLabel": "Search & Planning",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Algorithmic families for combinatorial search, path planning, task planning, and heuristic-guided exploration used in reasoning and decision-making systems.",
    "mars_cpg_example": "An algorithm that determines the most efficient route for a delivery truck to take to restock multiple warehouses.",
    "mars_wrigley_example": "Optimizing a delivery plan to restock Snickers and Twix across urban routes with limited truck capacity."
  },
  {
    "id": 12,
    "label": "Probabilistic Models",
    "shortLabel": "Probabilistic Models",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Models that represent uncertainty explicitly using probability theory (Bayesian networks, HMMs, probabilistic graphical models).",
    "mars_cpg_example": "Using a Bayesian network to model the probabilities of supply chain disruptions, from crop failure to shipping delays.",
    "mars_wrigley_example": "Bayesian model estimating risk of cocoa shipment delays impacting Galaxy bar production."
  },
  {
    "id": 13,
    "label": "Model Architectures & Generative AI",
    "shortLabel": "Model Architectures",
    "level": 1,
    "category": "Foundational Concepts",
    "definition": "Architectural families and generative modeling approaches that define how models are structured and how they generate new data (text, images, audio, video).",
    "mars_cpg_example": "Selecting the right architecture (CNN for images, Transformer for text) based on the specific business need.",
    "mars_wrigley_example": "Selecting CNNs for Maltesers visual QC and Transformers for ad copy generation."
  },
  {
    "id": 14,
    "label": "Transformer",
    "shortLabel": "Transformer",
    "level": 2,
    "category": "Models & Architectures",
    "definition": "A neural architecture based on self-attention mechanisms for processing sequences; the dominant backbone for modern LLMs and many multimodal models.",
    "mars_cpg_example": "The architecture used for an internal LLM that helps employees search and summarize millions of company documents.",
    "mars_wrigley_example": "A Transformer powering an internal assistant that summarizes M&M's campaign performance across markets."
  },
  {
    "id": 15,
    "label": "CNN (Convolutional Neural Network)",
    "shortLabel": "CNN",
    "level": 2,
    "category": "Models & Architectures",
    "definition": "Neural architecture designed to exploit spatially local patterns and translation equivariance, primarily used in vision tasks.",
    "mars_cpg_example": "A computer system that looks at photos of packaging and spots printing mistakes automatically.",
    "mars_wrigley_example": "CNN spotting micro-tears on Skittles pouch seams in real-time on the line."
  },
  {
    "id": 16,
    "label": "RNN (Recurrent Neural Network)",
    "shortLabel": "RNN",
    "level": 2,
    "category": "Models & Architectures",
    "definition": "Sequence-processing neural architecture that maintains internal state across time steps; historically important for language and time-series tasks (less common now for large-scale sequence models).",
    "mars_cpg_example": "A system that looks at what people usually buy next - like predicting that someone who bought pet food might soon need treats.",
    "mars_wrigley_example": "RNN analyzing store-level time series to predict when Altoids tins will stock out."
  },
  {
    "id": 17,
    "label": "LSTM (Long Short-Term Memory)",
    "shortLabel": "LSTM",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "A gated RNN variant that mitigates vanishing gradients and models longer-range temporal dependencies.",
    "mars_cpg_example": "Using an LSTM to forecast prices, as it can remember seasonal price patterns from many years ago.",
    "mars_wrigley_example": "LSTM capturing holiday seasonality to forecast Celebrations assortment demand."
  },
  {
    "id": 18,
    "label": "GRU (Gated Recurrent Unit)",
    "shortLabel": "GRU",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "A simplified gated RNN variant with fewer parameters than LSTM while providing comparable performance on many sequence tasks.",
    "mars_cpg_example": "A more efficient version of a forecasting model that runs on less powerful hardware in a regional distribution center.",
    "mars_wrigley_example": "GRU-based forecaster deployed on edge devices in a Bounty bar distribution center."
  },
  {
    "id": 19,
    "label": "GNN (Graph Neural Network)",
    "shortLabel": "GNN",
    "level": 2,
    "category": "Models & Architectures",
    "definition": "Neural architectures designed to operate on graph-structured data using message-passing and permutation-invariant aggregation.",
    "mars_cpg_example": "Understanding how a delay at one shipping port might affect the whole supply chain - kind of like seeing how one blocked road affects traffic everywhere.",
    "mars_wrigley_example": "Graph model simulating how a port delay cascades through Mars Wrigley’s global supply network."
  },
  {
    "id": 20,
    "label": "Modular Experts",
    "shortLabel": "Modular Experts",
    "level": 2,
    "category": "Models & Architectures",
    "definition": "A modular architecture that routes inputs to specialized sub-networks (experts), enabling scaling with sparsity and conditional computation.",
    "mars_cpg_example": "A large model for analyzing customer feedback where different expert sub-models handle comments about pricing, packaging, and flavor.",
    "mars_wrigley_example": "Expert sub-models specialized for chocolate, gum, and fruity candy comments to parse social feedback at scale."
  },
  {
    "id": 21,
    "label": "Generative Models",
    "shortLabel": "Generative Models",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Families of models trained to model the data distribution and generate new samples similar to the training data (includes autoregressive, GANs, VAEs, diffusion).",
    "mars_cpg_example": "Generating new product packaging design concepts for Mars chocolates based on existing brand imagery.",
    "mars_wrigley_example": "Generating packaging concept variations for Galaxy dark chocolate in local languages."
  },
  {
    "id": 22,
    "label": "Causal Decoders",
    "shortLabel": "Causal Decoders",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "Generative models that factorize joint distributions sequentially and generate new data by sampling the next element conditioned on previous ones (e.g., GPT-style decoders).",
    "mars_cpg_example": "A model that automatically writes a draft of a marketing email by generating one word at a time.",
    "mars_wrigley_example": "Auto-writing Twix product page copy one token at a time, guided by brand guidelines."
  },
  {
    "id": 23,
    "label": "VAE (Variational Autoencoder)",
    "shortLabel": "VAE",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "Latent-variable generative model using variational inference to learn an encoder and decoder with a continuous latent space.",
    "mars_cpg_example": "Generating new, plausible ingredient combinations for a new product flavor.",
    "mars_wrigley_example": "Sampling new gum flavor profiles for Airwaves within feasible ingredient ranges."
  },
  {
    "id": 24,
    "label": "GAN (Generative Adversarial Network)",
    "shortLabel": "GAN",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "Adversarial generative framework where a generator network produces samples and a discriminator distinguishes generated samples from real ones, trained in opposition.",
    "mars_cpg_example": "A model that generates realistic but synthetic images of dogs for an ad campaign.",
    "mars_wrigley_example": "GAN generating synthetic shelf images to train Skittles planogram compliance models."
  },
  {
    "id": 25,
    "label": "Diffusion Models",
    "shortLabel": "Diffusion Models",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "Generative models that learn to reverse a gradual noising process (diffusion) to sample complex data distributions; strong for high-fidelity image and audio generation.",
    "mars_cpg_example": "Typing a short description like 'a new strawberry chocolate bar' and having the computer create a realistic photo for it.",
    "mars_wrigley_example": "Diffusion model creating photorealistic images of a limited-edition M&M's pack from a text brief."
  },
  {
    "id": 26,
    "label": "Foundation Models",
    "shortLabel": "Foundation Models",
    "level": 2,
    "category": "Models & Architectures",
    "definition": "Large-scale pretrained models trained on broad, diverse datasets that serve as a base for fine-tuning or adaptation to many downstream tasks.",
    "mars_cpg_example": "Using a base model like GPT-4 or Claude as the starting point for building custom applications.",
    "mars_wrigley_example": "Starting from a general LLM and adapting it to Mars Wrigley product knowledge."
  },
  {
    "id": 27,
    "label": "Large Language Models (LLMs)",
    "shortLabel": "LLMs",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "Transformer-based, large-capacity language models pretrained on massive text corpora (and often multimodal data) capable of understanding and generating human language.",
    "mars_cpg_example": "Using a large language model like Google's Gemini to power a sophisticated internal search engine for R&D documents.",
    "mars_wrigley_example": "LLM that answers field sales queries about Snickers case sizes and promo calendars."
  },
  {
    "id": 28,
    "label": "GPT-4",
    "shortLabel": "GPT-4",
    "level": 4,
    "category": "Tools & Metrics",
    "definition": "A specific multimodal LLM family developed by OpenAI; categorized here as a representative model instance (tool/service).",
    "mars_cpg_example": "Leveraging GPT-4's capabilities to analyze both text and images from social media posts mentioning products.",
    "mars_wrigley_example": "Using GPT-4 to analyze shopper questions about Orbit on social and draft replies for review."
  },
  {
    "id": 29,
    "label": "Claude",
    "shortLabel": "Claude",
    "level": 4,
    "category": "Tools & Metrics",
    "definition": "Anthropic's family of LLMs emphasizing safety and alignment; represented here as a model instance/service.",
    "mars_cpg_example": "Using a Claude model for an external-facing chatbot due to its strong focus on safety and refusing inappropriate requests.",
    "mars_wrigley_example": "Using Claude to power a consumer-facing FAQ bot for Galaxy with strong safety filters."
  },
  {
    "id": 30,
    "label": "Gemini",
    "shortLabel": "Gemini",
    "level": 4,
    "category": "Tools & Metrics",
    "definition": "Google's family of large multimodal models and model services.",
    "mars_cpg_example": "Using Gemini to analyze complex datasets that include sales figures, marketing text, and product images simultaneously.",
    "mars_wrigley_example": "Gemini reviewing mixed media—POS photos, sales CSVs, and comments—for a Starburst launch."
  },
  {
    "id": 31,
    "label": "Llama",
    "shortLabel": "Llama",
    "level": 4,
    "category": "Tools & Metrics",
    "definition": "Meta's family of open-weight language models (representative instance).",
    "mars_cpg_example": "Deploying a Llama model on an internal server for a specific task to maintain full data privacy and control.",
    "mars_wrigley_example": "Deploying Llama on-prem to summarize sensitive supplier contracts for cocoa."
  },
  {
    "id": 32,
    "label": "Image Generation Models",
    "shortLabel": "Image Gen. Models",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "Models or architectures specialized for generating images from text, other images, or latent codes (often diffusion or GAN-based).",
    "mars_cpg_example": "Quickly creating concept art and mockups for new packaging designs from text prompts.",
    "mars_wrigley_example": "Creating moodboards for a Milky Way campaign directly from creative briefs."
  },
  {
    "id": 33,
    "label": "Stable Diffusion",
    "shortLabel": "Stable Diffusion",
    "level": 4,
    "category": "Tools & Metrics",
    "definition": "An open-source latent diffusion model for high-quality image generation.",
    "mars_cpg_example": "Generating creative, artistic images of characters for a new digital marketing campaign.",
    "mars_wrigley_example": "Rapidly exploring hundreds of Maltesers poster concepts before human selection."
  },
  {
    "id": 34,
    "label": "DALL-E",
    "shortLabel": "DALL-E",
    "level": 4,
    "category": "Tools & Metrics",
    "definition": "OpenAI's text-to-image model family (representative model/service).",
    "mars_cpg_example": "Quickly creating concept art and mockups for new packaging designs from text prompts.",
    "mars_wrigley_example": "Drafting celebratory seasonal artwork for Celebrations gift boxes."
  },
  {
    "id": 35,
    "label": "Midjourney",
    "shortLabel": "Midjourney",
    "level": 4,
    "category": "Tools & Metrics",
    "definition": "A proprietary image-generation service based on diffusion and other image models.",
    "mars_cpg_example": "Using Midjourney to create highly detailed, stylized images for a premium advertising campaign for chocolate.",
    "mars_wrigley_example": "Producing stylized hero visuals for a premium Galaxy digital campaign."
  },
  {
    "id": 36,
    "label": "Video Generation Models",
    "shortLabel": "Video Gen. Models",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "Model approaches and architectures that generate temporal visual sequences (video) from text, images, or latent representations.",
    "mars_cpg_example": "Automatically generating short video clips for social media ads from a single product image and a text prompt.",
    "mars_wrigley_example": "Auto-generating snackable 6-second Twix social ads from text scripts."
  },
  {
    "id": 37,
    "label": "Sora",
    "shortLabel": "Sora",
    "level": 4,
    "category": "Tools & Metrics",
    "definition": "Representative text-to-video diffusion model (as an instance).",
    "mars_cpg_example": "Creating a high-quality, conceptual video ad showing a fantastical world made of candy, based on a detailed script.",
    "mars_wrigley_example": "Creating a concept video touring an imaginative 'City of Candy' for Skittles."
  },
  {
    "id": 38,
    "label": "Multimodal Models",
    "shortLabel": "Multimodal Models",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "Models designed to process and (optionally) generate across multiple modalities such as text, vision, and audio.",
    "mars_cpg_example": "A single model that can analyze a social media post by understanding the image, the text caption, and the sentiment of the comments.",
    "mars_wrigley_example": "A model that reads a shelf photo and caption to assess M&M's share of shelf and sentiment tone."
  },
  {
    "id": 39,
    "label": "CLIP",
    "shortLabel": "CLIP",
    "level": 4,
    "category": "Tools & Metrics",
    "definition": "Contrastive image-text model aligning visual and textual representations in a shared embedding space.",
    "mars_cpg_example": "Powering a search engine where a marketing employee can find images by typing descriptions, e.g., 'a dog happily eating from a red bowl'.",
    "mars_wrigley_example": "Searching the asset library with 'hand pouring colorful candies into bowl' to find M&M's visuals."
  },
  {
    "id": 40,
    "label": "Data, Retrieval & Knowledge Systems",
    "shortLabel": "Data & Knowledge",
    "level": 1,
    "category": "Foundational Concepts",
    "definition": "Systems and techniques for storing, structuring, retrieving, and augmenting data to support AI models and applications.",
    "mars_cpg_example": "The overall strategy for storing, cleaning, and retrieving petabyte-scale sales data for analysis.",
    "mars_wrigley_example": "Centralizing product specs, POS data, and creative assets for all Mars Wrigley brands."
  },
  {
    "id": 41,
    "label": "Data Processing",
    "shortLabel": "Data Processing",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Data cleaning, normalization, transformation, labeling, augmentation, and pipeline best practices used to prepare data for model training and inference.",
    "mars_cpg_example": "Cleaning and standardizing sales data from different regional systems before feeding it to forecasting models.",
    "mars_wrigley_example": "Normalizing retailer IDs across Snickers, Twix, and Bounty sales feeds."
  },
  {
    "id": 42,
    "label": "Tokenization",
    "shortLabel": "Tokenization",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Techniques for converting text into discrete tokens (subwords, bytes, characters) suitable for model inputs and vocabulary design.",
    "mars_cpg_example": "The first step in analyzing customer reviews: breaking down sentences into words and sub-words for the model to understand.",
    "mars_wrigley_example": "Tokenizing multi-language packaging text for Galaxy to support translation models."
  },
  {
    "id": 43,
    "label": "Embeddings",
    "shortLabel": "Embeddings",
    "level": 3,
    "category": "Foundational Concepts",
    "definition": "Continuous vector representations that encode semantic information about items (words, sentences, images) enabling similarity search and downstream tasks.",
    "mars_cpg_example": "Representing different product brands as numerical vectors, where similar brands are mathematically close.",
    "mars_wrigley_example": "Embedding product SKUs and shopper queries to power semantic search on mars.com."
  },
  {
    "id": 44,
    "label": "Chunking",
    "shortLabel": "Chunking",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Segmenting long documents or streams into manageable pieces (chunks) for retrieval, context-windowing, or streaming inference.",
    "mars_cpg_example": "Breaking down a 50-page market research report into smaller paragraphs (chunks) so an LLM can effectively find answers within it.",
    "mars_wrigley_example": "Chunking 80-page media reports so an LLM can extract insights for Orbit campaigns."
  },
  {
    "id": 45,
    "label": "Synthetic Data",
    "shortLabel": "Synthetic Data",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Artificially generated data used to augment training datasets, preserve privacy, or simulate rare conditions; may be generated via generative models or domain simulators.",
    "mars_cpg_example": "Creating thousands of simulated sales data records to test a new forecasting model before it goes live.",
    "mars_wrigley_example": "Generating synthetic QC images of rare wrapper defects on Starburst lines."
  },
  {
    "id": 46,
    "label": "Retrieval Systems",
    "shortLabel": "Retrieval Systems",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Systems and algorithms for retrieving relevant documents or passages from large corpora, often used to ground generative models (RAG).",
    "mars_cpg_example": "Building a system that can instantly find relevant product information from millions of documents.",
    "mars_wrigley_example": "RAG pulling the latest M&M's flavor guidelines into the copy generator."
  },
  {
    "id": 47,
    "label": "Vector Databases",
    "shortLabel": "Vector Databases",
    "level": 3,
    "category": "Tools & Metrics",
    "definition": "Specialized stores for high-dimensional vectors (embeddings) supporting approximate nearest neighbor (ANN) search and metadata filtering.",
    "mars_cpg_example": "A database that stores vector embeddings of all product images, allowing someone to search for specific visual characteristics.",
    "mars_wrigley_example": "Storing embeddings for thousands of gum and mint product images for visual search."
  },
  {
    "id": 48,
    "label": "ANN Search",
    "shortLabel": "ANN Search",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Approximate Nearest Neighbor algorithms and libraries (HNSW, IVF, PQ) used for fast similarity search over embeddings.",
    "mars_cpg_example": "Quickly finding the top 100 customer reviews that are most similar in meaning to the query 'the packaging was damaged'.",
    "mars_wrigley_example": "Quickly finding similar complaints to 'Twix caramel too hard' in support logs."
  },
  {
    "id": 49,
    "label": "BM25",
    "shortLabel": "BM25",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "A classic sparse retrieval ranking function based on term frequency and inverse document frequency; commonly used as a baseline in IR systems.",
    "mars_cpg_example": "A simple keyword-based search algorithm used as a baseline to measure the performance of a more advanced semantic search model.",
    "mars_wrigley_example": "Baseline keyword search for 'Skittles sour allergen info' in the help center."
  },
  {
    "id": 50,
    "label": "Reranking",
    "shortLabel": "Reranking",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Applying a stronger, often neural, model to re-evaluate and reorder an initial set of retrieved candidates for improved precision.",
    "mars_cpg_example": "After an initial search finds 100 relevant documents, a more powerful model re-ranks them to put the single most relevant document at the top.",
    "mars_wrigley_example": "Neural reranker to surface the most relevant Galaxy sustainability doc first."
  },
  {
    "id": 51,
    "label": "Knowledge Graphs",
    "shortLabel": "Knowledge Graphs",
    "level": 2,
    "category": "Tools & Metrics",
    "definition": "Structured representations of entities, relations, and schema used for semantic reasoning, entity linking, and hybrid retrieval.",
    "mars_cpg_example": "A big map that shows how everything in the company is connected - from ingredients to products to where they're sold.",
    "mars_wrigley_example": "A graph linking ingredients, allergens, SKUs, and regions for Mars Wrigley compliance."
  },
  {
    "id": 52,
    "label": "RAG (Retrieval-Augmented Generation)",
    "shortLabel": "RAG",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "A pipeline that retrieves external documents or facts and conditions a generative model on them to improve factuality and domain coverage.",
    "mars_cpg_example": "A smart assistant that can look through company documents and give quick, clear answers without you reading the whole file.",
    "mars_wrigley_example": "Assistant that grounds answers in Twix spec sheets and retailer guidelines."
  },
  {
    "id": 53,
    "label": "Context Window",
    "shortLabel": "Context Window",
    "level": 2,
    "category": "Foundational Concepts",
    "definition": "The span of tokens a model can accept as input (or effectively condition on) during inference or training; affects how much context a model can attend to.",
    "mars_cpg_example": "Ensuring an LLM can summarize a long internal Mars report by splitting it into chunks that fit its context window.",
    "mars_wrigley_example": "Ensuring the assistant can read an entire M&M's brand book via sliding windows."
  },
  {
    "id": 54,
    "label": "Model Training, Tuning & Evaluation",
    "shortLabel": "Model Training & Eval",
    "level": 1,
    "category": "Foundational Concepts",
    "definition": "Practices, methodologies, and metrics for building, adapting, and assessing AI models across development cycles.",
    "mars_cpg_example": "The process of taking a general-purpose language model and fine-tuning it to speak in an official brand voice.",
    "mars_wrigley_example": "Systematically fine-tuning models to speak in the Snickers tone and testing output safety."
  },
  {
    "id": 55,
    "label": "Pretraining",
    "shortLabel": "Pretraining",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Large-scale unsupervised or self-supervised training on broad datasets to learn general-purpose representations (foundation models).",
    "mars_cpg_example": "Using a model like GPT-4 that has been pretrained on a vast amount of internet text as the starting point for a specific chatbot.",
    "mars_wrigley_example": "Leveraging a pretrained LLM before adapting it to Mars Wrigley packaging voice."
  },
  {
    "id": 56,
    "label": "Fine Tuning",
    "shortLabel": "Fine Tuning",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Adapting a pretrained model to a target task or domain via additional supervised or specialized training.",
    "mars_cpg_example": "Teaching an AI to talk in your brand's unique voice by showing it your company's past marketing messages.",
    "mars_wrigley_example": "Fine-tuning on approved Galaxy copy to maintain brand cadence."
  },
  {
    "id": 57,
    "label": "Instruction Tuning",
    "shortLabel": "Instruction Tuning",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Fine-tuning a model on instruction/response pairs to improve its ability to follow human instructions and generalize to new prompts.",
    "mars_cpg_example": "Further training a model with question-answer pairs so it becomes better at responding to specific commands like 'Summarize last week's sales report'.",
    "mars_wrigley_example": "Teaching the assistant to follow commands like 'summarize Skittles Q2 uplift by market'."
  },
  {
    "id": 58,
    "label": "PEFT (Parameter-Efficient Fine-Tuning)",
    "shortLabel": "PEFT",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Techniques (adapters, LoRA, prompt-tuning) that modify a small subset of parameters or add lightweight modules to adapt large models efficiently.",
    "mars_cpg_example": "Making a big AI smarter for each brand without having to build it from scratch every time.",
    "mars_wrigley_example": "Applying adapters so one base model serves both Orbit and Starburst teams."
  },
  {
    "id": 59,
    "label": "LoRA (Low-Rank Adaptation)",
    "shortLabel": "LoRA",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "A popular PEFT method that injects low-rank updates into weight matrices to enable efficient fine-tuning with reduced compute and storage.",
    "mars_cpg_example": "A specific, popular PEFT technique used to efficiently fine-tune a model to understand specific jargon and acronyms.",
    "mars_wrigley_example": "Using LoRA to cheaply adapt a model to M&M's playful voice."
  },
  {
    "id": 60,
    "label": "Alignment Methods",
    "shortLabel": "Alignment Methods",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Approaches and practices to align model behavior with human values, safety constraints, and stakeholder objectives.",
    "mars_cpg_example": "Ensuring an internal HR chatbot will refuse to answer inappropriate questions based on company values.",
    "mars_wrigley_example": "Applying constitutional prompts so HR bots at Mars Wrigley decline inappropriate queries."
  },
  {
    "id": 61,
    "label": "RLHF (Reinforcement Learning from Human Feedback)",
    "shortLabel": "RLHF",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "A technique using human preference labels to train a reward model and then optimize the main model (policy) using reinforcement learning to better match human preferences.",
    "mars_cpg_example": "Fine-tuning a generative AI that creates new slogans by having brand managers rank their favorite options, teaching the model what humans prefer.",
    "mars_wrigley_example": "Brand managers rank new Altoids taglines to steer the generator toward on-brand options."
  },
  {
    "id": 62,
    "label": "RLAIF (Reinforcement Learning from AI Feedback)",
    "shortLabel": "RLAIF",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "A variant of RLHF where automated or synthetic evaluators produce preference signals, often used to scale feedback collection (note: carries risks of feedback loop bias).",
    "mars_cpg_example": "Using a powerful 'judge' AI to rank the outputs of a marketing text generator, automating the feedback process.",
    "mars_wrigley_example": "A judge model auto-scores candidate Snickers headlines for compliance before human review."
  },
  {
    "id": 63,
    "label": "AI Constitution",
    "shortLabel": "AI Constitution",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "An alignment strategy where a model is guided by an explicit set of policies, principles or a 'constitution' to judge and revise outputs without requiring human labels for every decision.",
    "mars_cpg_example": "Ensuring an internal HR chatbot will refuse to answer inappropriate questions, based on a pre-defined 'constitution' of company policies.",
    "mars_wrigley_example": "Embedding Mars values and marketing policies as a 'constitution' for copy assistants."
  },
  {
    "id": 64,
    "label": "Model Optimization",
    "shortLabel": "Model Optimization",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Techniques (quantization, pruning, distillation, compiler optimizations) used to reduce model latency, memory, and compute requirements for deployment.",
    "mars_cpg_example": "Making a large AI model run efficiently on factory floor hardware with limited computing power.",
    "mars_wrigley_example": "Quantizing a shelf-scanning model to run on a low-power tablet used by field reps."
  },
  {
    "id": 65,
    "label": "Quantization",
    "shortLabel": "Quantization",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Reducing numerical precision of model weights/activations (e.g., FP16, INT8, 4-bit) to reduce memory footprint and accelerate inference, with trade-offs in accuracy.",
    "mars_cpg_example": "Making the AI small and fast enough to work on a factory camera instead of a big computer.",
    "mars_wrigley_example": "INT8 quantization to speed up on-line Skittles defect detection."
  },
  {
    "id": 66,
    "label": "Pruning",
    "shortLabel": "Pruning",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Removing less important weights, neurons, or attention heads from a model to reduce size and sometimes improve inference speed.",
    "mars_cpg_example": "Making a large demand forecasting model smaller and faster by removing redundant neural connections without losing significant accuracy.",
    "mars_wrigley_example": "Pruning an M&M's demand model to fit retailer edge boxes while keeping accuracy."
  },
  {
    "id": 67,
    "label": "Knowledge Distillation",
    "shortLabel": "Knowledge Distillation",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Training a smaller student model to imitate a larger teacher model's behavior, transferring capability while reducing resource needs.",
    "mars_cpg_example": "Training a small, fast model to run on a factory floor computer by having it learn from a much larger, more powerful model that runs in the cloud.",
    "mars_wrigley_example": "Distilling a large Galaxy response bot into a fast mobile model for promoters."
  },
  {
    "id": 68,
    "label": "Model Evaluation",
    "shortLabel": "Model Evaluation",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Metrics, testing frameworks, benchmarks, and evaluation procedures to measure model performance, robustness, fairness, and safety.",
    "mars_cpg_example": "Evaluating different LLMs for generating product descriptions by comparing their perplexity scores and human preferences.",
    "mars_wrigley_example": "Benchmarking LLMs on brand voice, factuality, and safety for Orbit."
  },
  {
    "id": 69,
    "label": "Perplexity",
    "shortLabel": "Perplexity",
    "level": 3,
    "category": "Tools & Metrics",
    "definition": "A measure of how well a probabilistic model predicts a sample; commonly used for language models (lower perplexity indicates better predictive performance).",
    "mars_cpg_example": "Evaluating different LLMs for generating product descriptions by comparing their perplexity scores.",
    "mars_wrigley_example": "Using perplexity to pick the best model for Milky Way product description generation."
  },
  {
    "id": 70,
    "label": "Continual Learning",
    "shortLabel": "Continual Learning",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Techniques for updating models incrementally on new data while avoiding catastrophic forgetting of previously learned knowledge.",
    "mars_cpg_example": "A demand forecast model that constantly updates its predictions every hour as new, real-time sales data streams in from retailers.",
    "mars_wrigley_example": "Updating forecasts hourly as new Extra gum POS data streams in."
  },
  {
    "id": 71,
    "label": "Meta Learning",
    "shortLabel": "Meta Learning",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Approaches that enable models to learn learning algorithms or initialization states that speed adaptation to new tasks (\"learning to learn\").",
    "mars_cpg_example": "Developing a model that can quickly learn to predict sales for a new product by leveraging what it has learned from forecasting other brands.",
    "mars_wrigley_example": "A meta-learner that adapts quickly to sales patterns of a new limited-edition Skittles flavor."
  },
  {
    "id": 72,
    "label": "Multi-Task Learning",
    "shortLabel": "Multi-Task Learning",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Training models to perform multiple related tasks simultaneously to improve generalization and parameter sharing.",
    "mars_cpg_example": "Training a single model to simultaneously predict demand for multiple products, sharing knowledge between the brands.",
    "mars_wrigley_example": "One model predicts promo uplift for Snickers, Twix, and Bounty jointly."
  },
  {
    "id": 73,
    "label": "Prompting, Inference & Agents",
    "shortLabel": "Prompting & Agents",
    "level": 1,
    "category": "Foundational Concepts",
    "definition": "Interaction techniques, inference-time methods, and agentic architectures for steering models and building autonomous systems.",
    "mars_cpg_example": "The process of designing the perfect question (prompt) to ask a generative AI to get the best possible marketing copy.",
    "mars_wrigley_example": "Designing prompts that yield compliant copy for DOVE Chocolate in China."
  },
  {
    "id": 74,
    "label": "Prompt Engineering",
    "shortLabel": "Prompt Engineering",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Designing, testing, and optimizing prompts, templates, and context to elicit desired behaviors from models during inference.",
    "mars_cpg_example": "Asking the AI the right way - like telling it exactly what tone or style you want for your press release.",
    "mars_wrigley_example": "Including target audience and CTA in prompts to improve Twix ad copy."
  },
  {
    "id": 75,
    "label": "Zero-Shot Prompting",
    "shortLabel": "Zero-Shot Prompting",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Prompting approach where a task is specified only via instructions, with no examples provided.",
    "mars_cpg_example": "Asking a powerful LLM to 'Translate this English ad copy into Spanish' without providing any prior Spanish examples.",
    "mars_wrigley_example": "Translating Orbit FAQs to Polish with just an instruction, no examples."
  },
  {
    "id": 76,
    "label": "Few-Shot Learning",
    "shortLabel": "Few-Shot Learning",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Providing a small number of exemplars in the prompt or via adaptation to help the model generalize to a new task.",
    "mars_cpg_example": "Asking an LLM to generate a new slogan by showing it three examples of successful past slogans for the brand.",
    "mars_wrigley_example": "Providing three iconic Snickers lines to guide new copy variants."
  },
  {
    "id": 77,
    "label": "Chain of Thought",
    "shortLabel": "Chain of Thought",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Prompting or model-training techniques that elicit intermediate reasoning steps to improve complex problem solving and transparency.",
    "mars_cpg_example": "Prompting a model to 'Explain the steps to calculate a 5% increase in production, then provide the final number' to ensure accuracy.",
    "mars_wrigley_example": "Asking the model to reason step-by-step through a trade promo ROI calc for M&M's."
  },
  {
    "id": 78,
    "label": "Tree of Thought",
    "shortLabel": "Tree of Thought",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "A structured reasoning approach that explores multiple candidate reasoning branches using search and backtracking to improve solution quality.",
    "mars_cpg_example": "A model that explores multiple possible solutions for a complex supply chain problem, evaluates each one, and backtracks if it hits a dead end.",
    "mars_wrigley_example": "Exploring multiple shelf reset strategies for Starburst and selecting the best."
  },
  {
    "id": 79,
    "label": "Self Consistency",
    "shortLabel": "Self Consistency",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Sampling and aggregating multiple reasoning traces (or outputs) to increase robustness and select consensus answers.",
    "mars_cpg_example": "Having a model generate five different step-by-step explanations for a sales anomaly and then picking the most common answer as the correct one.",
    "mars_wrigley_example": "Sampling multiple root-cause analyses for a Galaxy sales dip and voting on consensus."
  },
  {
    "id": 80,
    "label": "Inference Techniques",
    "shortLabel": "Inference Techniques",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Algorithmic and system-level approaches to run models efficiently at inference time (batching, caching, decoding strategies, speculative decoding).",
    "mars_cpg_example": "Optimizing how a chatbot generates responses to handle thousands of simultaneous users.",
    "mars_wrigley_example": "Batching responses so the Celebrations chatbot can handle holiday traffic."
  },
  {
    "id": 81,
    "label": "Decoding Strategies",
    "shortLabel": "Decoding Strategies",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Sampling and search-based algorithms (greedy, beam, top-k, top-p, temperature) that trade off diversity and fidelity in generation.",
    "mars_cpg_example": "Choosing a decoding strategy that produces more creative and diverse ad slogans, even if some are less grammatically perfect.",
    "mars_wrigley_example": "Using higher temperature to brainstorm playful Hubba Bubba taglines."
  },
  {
    "id": 82,
    "label": "Speculative Decoding",
    "shortLabel": "Speculative Decoding",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "A technique using a smaller/faster draft model to propose candidates which are then verified or rescored by a larger model to accelerate generation.",
    "mars_cpg_example": "Using a small, fast model to generate a draft response which is then checked and corrected by a larger, more powerful model to speed up chatbot responses.",
    "mars_wrigley_example": "Drafting answers with a small model, verifying with a larger one for Snickers support."
  },
  {
    "id": 83,
    "label": "KV Cache",
    "shortLabel": "KV Cache",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Caching mechanism for transformer key/value activations to avoid recomputing earlier layers when generating long sequences, improving latency for autoregressive inference.",
    "mars_cpg_example": "A memory-saving technique that helps an LLM remember the beginning of a long market research document while it's summarizing the end.",
    "mars_wrigley_example": "Caching attention keys to speed long Twix plan documents summarization."
  },
  {
    "id": 84,
    "label": "Structured Output",
    "shortLabel": "Structured Output",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Techniques for constraining model outputs into machine-readable formats or schemas (JSON, XML, canonical templates) and validating them.",
    "mars_cpg_example": "Training a model with historical data of ad campaigns and their sales uplift to predict the success of a new ad.",
    "mars_wrigley_example": "Enforcing JSON schema when the assistant returns M&M's SKU attributes."
  },
  {
    "id": 85,
    "label": "Agentic AI",
    "shortLabel": "Agentic AI",
    "level": 2,
    "category": "Models & Architectures",
    "definition": "Systems in which models take sequential actions (plan, act, call tools, observe) to achieve goals autonomously under supervision or constraints.",
    "mars_cpg_example": "A helpful digital assistant that watches online conversations and suggests polite replies if someone posts something negative.",
    "mars_wrigley_example": "An agent that plans, drafts, and submits Orbit social posts for approval using integrated tools."
  },
  {
    "id": 86,
    "label": "Tool Use",
    "shortLabel": "Tool Use",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Patterns and interfaces for enabling models to call external APIs, databases, or tools to augment capabilities and access up-to-date information or actions.",
    "mars_cpg_example": "An LLM that, when asked 'What's the weather in our main cocoa supplier region?', can call a weather API to get the real-time answer.",
    "mars_wrigley_example": "LLM calls a pricing API to fetch latest Extra gum RRP by market."
  },
  {
    "id": 87,
    "label": "ReAct",
    "shortLabel": "ReAct",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "A prompting and agent framework that interleaves explicit reasoning traces with tool actions (Reason+Act) to solve tasks requiring external calls.",
    "mars_cpg_example": "A model that thinks 'I need to know next month's forecast,' then decides to use the 'SalesAPI' tool, gets the data, and then reasons about the result.",
    "mars_wrigley_example": "Reasoning 'need sell-out data' then calling 'RetailerAPI' to finish a Skittles analysis."
  },
  {
    "id": 88,
    "label": "Memory Systems",
    "shortLabel": "Memory Systems",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Persistent or semi-persistent external stores that record facts, user preferences, or interaction history for agents to recall and condition behavior.",
    "mars_cpg_example": "Providing a customer service chatbot with a database of past conversations so it can remember a user's previous issues.",
    "mars_wrigley_example": "Remembering a retailer's preferences when generating future Galaxy pitches."
  },
  {
    "id": 89,
    "label": "Multi-Agent Systems",
    "shortLabel": "Multi-Agent Systems",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "Architectures where multiple agents interact, coordinate, or negotiate to solve tasks collectively or competitively.",
    "mars_cpg_example": "A 'marketing agent' debates with a 'finance agent' and a 'supply chain agent' to come up with the optimal plan for a new product launch.",
    "mars_wrigley_example": "Creative, legal, and brand agents negotiate a compliant Altoids campaign."
  },
  {
    "id": 90,
    "label": "Orchestration Frameworks",
    "shortLabel": "Orchestration Frameworks",
    "level": 3,
    "category": "Tools & Metrics",
    "definition": "Libraries and platforms (LangChain, LlamaIndex, Ray, etc.) for composing retrieval, tools, agents, and orchestration logic.",
    "mars_cpg_example": "Using the LangChain framework to build a complex AI agent that can query databases, search documents, and summarize the results.",
    "mars_wrigley_example": "Using LangChain to compose RAG + tools for a field-sales assistant."
  },
  {
    "id": 91,
    "label": "MCP (Model Context Protocol)",
    "shortLabel": "MCP",
    "level": 3,
    "category": "Tools & Metrics",
    "definition": "Open standards or protocols designed to connect models to external contexts, tools, and data sources in a secure and standardized way.",
    "mars_cpg_example": "Using a standardized protocol to allow a new internal AI agent to securely access existing sales data APIs.",
    "mars_wrigley_example": "Standardized connectors allow the M&M's bot to securely access DAM and PIM systems."
  },
  {
    "id": 92,
    "label": "Ethics, Governance & Trust",
    "shortLabel": "Ethics & Governance",
    "level": 1,
    "category": "Foundational Concepts",
    "definition": "Principles, policy, and operational practices that ensure AI systems are developed, deployed, and monitored responsibly.",
    "mars_cpg_example": "Establishing company-wide guidelines to ensure all AI systems are fair, transparent, and aligned with company values.",
    "mars_wrigley_example": "Mars Wrigley codifies rules for responsible AI in consumer marketing and customer support."
  },
  {
    "id": 93,
    "label": "Model Alignment",
    "shortLabel": "Model Alignment",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Techniques and evaluation approaches to ensure model objectives and behaviors are consistent with human values and specified constraints.",
    "mars_cpg_example": "Designing a Mars HR chatbot to follow ethical guidelines and refuse inappropriate requests.",
    "mars_wrigley_example": "Guardrails ensure Orbit chatbots avoid health claims beyond approved language."
  },
  {
    "id": 94,
    "label": "Model Explainability (XAI)",
    "shortLabel": "XAI",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Methods to interpret and explain model predictions and internal behavior to stakeholders for debugging, compliance, and trust.",
    "mars_cpg_example": "Explaining why a predictive model recommends raising promotional spend for a specific brand.",
    "mars_wrigley_example": "SHAP plots show which features drove Twix promo uplift predictions."
  },
  {
    "id": 95,
    "label": "Model Bias",
    "shortLabel": "Model Bias",
    "level": 2,
    "category": "Model Challenges",
    "definition": "Systematic deviations or unfair outcomes arising from biased training data, model architectures, or evaluation methods; a key governance concern.",
    "mars_cpg_example": "An AI that thinks one market will sell more just because it has seen more examples from that region - not because it's actually true.",
    "mars_wrigley_example": "Auditing that language models don't favor one region’s slang in Skittles copy."
  },
  {
    "id": 96,
    "label": "Semantic Drift",
    "shortLabel": "Semantic Drift",
    "level": 2,
    "category": "Model Challenges",
    "definition": "When a model’s meaning or context shifts during generation, causing gradual, subtle hallucination in its output.",
    "mars_cpg_example": "A chatbot accidentally making up a product that doesn't exist - like saying 'Mint Mars Bar' when there isn't one.",
    "mars_wrigley_example": "RAG prevents the bot from inventing a non-existent 'peanut-free Snickers'."
  },
  {
    "id": 97,
    "label": "AI Governance",
    "shortLabel": "AI Governance",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Engineering practices, verification methods, and monitoring to reduce risks of harm from AI systems (robustness, adversarial testing, kill-switches).",
    "mars_cpg_example": "Implementing safeguards to prevent an AI system from making automated decisions that could harm customers or the brand.",
    "mars_wrigley_example": "Red-team tests and a kill-switch for auto-pricing agents on vending machines."
  },
  {
    "id": 98,
    "label": "Data Privacy & Security",
    "shortLabel": "Data Privacy & Sec.",
    "level": 2,
    "category": "Algorithm & Techniques",
    "definition": "Techniques and controls (differential privacy, encryption, access control) to protect sensitive data used by AI systems and comply with regulations.",
    "mars_cpg_example": "Ensuring customer data used for personalization is anonymized and complies with GDPR regulations.",
    "mars_wrigley_example": "Anonymizing shopper data used to personalize M&M's emails in the EU."
  },
  {
    "id": 100,
    "label": "AI Use Cases",
    "shortLabel": "AI Use Cases",
    "level": 1,
    "category": "Foundational Concepts",
    "definition": "Representations of real-world applications and business functions where AI technologies deliver value.",
    "mars_cpg_example": "Mapping AI applications across the value chain from supply chain optimization to personalized marketing.",
    "mars_wrigley_example": "Mapping AI across Mars Wrigley: QC vision, demand forecasting, and creative generation."
  },
  {
    "id": 101,
    "label": "Content Generation",
    "shortLabel": "Content Generation",
    "level": 2,
    "category": "Use Cases",
    "definition": "Using generative AI to produce textual, visual, audio, or multimodal creative assets for marketing, entertainment, and production.",
    "mars_cpg_example": "Automatically generating product descriptions, social media posts, and email marketing campaigns for different brands.",
    "mars_wrigley_example": "Auto-creating creative variants for Galaxy Ramadan promotions."
  },
  {
    "id": 102,
    "label": "Marketing Copy Generation",
    "shortLabel": "Marketing Copy Gen.",
    "level": 3,
    "category": "Use Cases",
    "definition": "Generating brand-aligned advertising, product descriptions, and promotional text at scale.",
    "mars_cpg_example": "Using an LLM to create dozens of variations of ad copy for A/B testing across different markets.",
    "mars_wrigley_example": "Generating localized Snickers headlines for LATAM."
  },
  {
    "id": 103,
    "label": "Creative Asset Generation",
    "shortLabel": "Creative Asset Gen.",
    "level": 3,
    "category": "Use Cases",
    "definition": "Creating images, videos, audio clips, and other multimedia assets using generative models and production pipelines.",
    "mars_cpg_example": "Generating product visualization images and video concepts for new product launches without expensive photoshoots.",
    "mars_wrigley_example": "Synthesizing POS mockups for Orbit endcaps."
  },
  {
    "id": 104,
    "label": "Personalized Experience",
    "shortLabel": "Personalized Experience",
    "level": 3,
    "category": "Use Cases",
    "definition": "Tailoring product recommendations, content, or experiences to individual users using models trained on behavior and preference signals.",
    "mars_cpg_example": "Creating personalized email campaigns where the content, offers, and product recommendations adapt to each customer's purchase history.",
    "mars_wrigley_example": "Tailoring email offers: mint lovers see Extra and Altoids; chocolate lovers see Galaxy."
  },
  {
    "id": 105,
    "label": "Demand Forecasting",
    "shortLabel": "Demand Forecasting",
    "level": 2,
    "category": "Use Cases",
    "definition": "Predictive analytics to estimate future product demand using historical sales, seasonality, and exogenous signals.",
    "mars_cpg_example": "Using AI to guess how much ice cream people will want next week by looking at the weather, holidays, and past sales.",
    "mars_wrigley_example": "Forecasting Skittles demand spikes during Pride events using exogenous signals."
  },
  {
    "id": 106,
    "label": "Inventory Optimization",
    "shortLabel": "Inventory Optimization",
    "level": 3,
    "category": "Use Cases",
    "definition": "Optimizing stock levels, reorder policies, and distribution using forecasts and optimization algorithms.",
    "mars_cpg_example": "AI system that automatically adjusts inventory levels to minimize waste while preventing stockouts.",
    "mars_wrigley_example": "Balancing M&M's safety stock to prevent out-of-stocks without overholding."
  },
  {
    "id": 107,
    "label": "Price Optimization",
    "shortLabel": "Price Optimization",
    "level": 3,
    "category": "Use Cases",
    "definition": "Dynamic pricing strategies that use demand signals, competition data, and elasticity models to set prices.",
    "mars_cpg_example": "Reinforcement learning system that adjusts vending machine prices in real-time based on location, time, and demand.",
    "mars_wrigley_example": "Dynamically adjusting vending prices for Twix near campuses by time of day."
  },
  {
    "id": 108,
    "label": "Customer Intelligence",
    "shortLabel": "Customer Intelligence",
    "level": 2,
    "category": "Use Cases",
    "definition": "Analyzing customer data to derive segmentation, lifetime value, and behavior insights for business decisions.",
    "mars_cpg_example": "Using AI to analyze millions of customer reviews and social media posts to understand sentiment and emerging trends.",
    "mars_wrigley_example": "Mining TikTok to spot early trends for Hubba Bubba flavors."
  },
  {
    "id": 109,
    "label": "Sentiment Analysis",
    "shortLabel": "Sentiment Analysis",
    "level": 3,
    "category": "Use Cases",
    "definition": "Classifying text or speech to determine opinion, sentiment, and emotional tone for feedback and monitoring.",
    "mars_cpg_example": "Keeping an eye on what people say online and warning the brand team if customers sound unhappy.",
    "mars_wrigley_example": "Flagging negative sentiment during a Milky Way packaging change rollout."
  },
  {
    "id": 110,
    "label": "Customer Segmentation",
    "shortLabel": "Customer Segmentation",
    "level": 3,
    "category": "Use Cases",
    "definition": "Grouping customers into meaningful cohorts for targeted marketing, personalized experiences, or product design.",
    "mars_cpg_example": "Using unsupervised learning to discover natural customer segments for targeted marketing campaigns.",
    "mars_wrigley_example": "Grouping shoppers into 'gum on-the-go' vs 'chocolate treat' cohorts for targeting."
  },
  {
    "id": 111,
    "label": "Churn Prediction",
    "shortLabel": "Churn Prediction",
    "level": 3,
    "category": "Use Cases",
    "definition": "Predicting which customers are likely to stop using a product or service so retention strategies can be applied.",
    "mars_cpg_example": "Spotting stores that might stop selling a product so the team can talk to them before it happens.",
    "mars_wrigley_example": "Predicting which convenience stores may drop Orbit and triggering outreach."
  },
  {
    "id": 112,
    "label": "Supply Chain Optimization",
    "shortLabel": "Supply Chain Optim.",
    "level": 2,
    "category": "Use Cases",
    "definition": "Applying AI to logistics, routing, procurement, and inventory decisions to reduce cost and improve service levels.",
    "mars_cpg_example": "AI-powered system that optimizes delivery routes, predicts disruptions, and recommends alternative suppliers.",
    "mars_wrigley_example": "Optimizing truck routes for Snickers across multi-stop deliveries."
  },
  {
    "id": 113,
    "label": "Route Optimization",
    "shortLabel": "Route Optimization",
    "level": 3,
    "category": "Use Cases",
    "definition": "Computing efficient delivery or travel routes using vehicle constraints, time windows, and traffic forecasts.",
    "mars_cpg_example": "Using search algorithms to determine the most efficient routes for delivery trucks to restock multiple warehouses.",
    "mars_wrigley_example": "Computing routes to service gas stations with Extra gum restocks under time windows."
  },
  {
    "id": 114,
    "label": "Supplier Risk Analysis",
    "shortLabel": "Supplier Risk",
    "level": 3,
    "category": "Use Cases",
    "definition": "Assessing supplier reliability and disruption risk using structured and unstructured data sources.",
    "mars_cpg_example": "Using probabilistic models to assess the risk of cocoa supply disruptions due to weather, political instability, or market factors.",
    "mars_wrigley_example": "Assessing risk to cocoa supply for Galaxy from weather shocks."
  },
  {
    "id": 115,
    "label": "Quality Control",
    "shortLabel": "Quality Control",
    "level": 2,
    "category": "Use Cases",
    "definition": "Automated inspection, defect detection, and QA workflows using computer vision and sensor analytics in manufacturing.",
    "mars_cpg_example": "Using AI-powered vision systems to detect packaging defects or label misprints in confectionery lines, ensuring only compliant products reach distribution.",
    "mars_wrigley_example": "Vision system rejects missealed Starburst pouches in-line."
  },
  {
    "id": 116,
    "label": "Visual Inspection",
    "shortLabel": "Visual Inspection",
    "level": 3,
    "category": "Use Cases",
    "definition": "Computer-vision-based detection and classification of product defects, assembly errors, and quality deviations.",
    "mars_cpg_example": "CNN-based system that identifies printing errors, damaged packaging, or misaligned labels on the production line.",
    "mars_wrigley_example": "Detecting skewed Twix labels with high-speed cameras."
  },
  {
    "id": 117,
    "label": "Predictive Maintenance",
    "shortLabel": "Predictive Maintenance",
    "level": 3,
    "category": "Use Cases",
    "definition": "Forecasting equipment failures using sensor data, anomaly detection, and lifetime models to schedule maintenance proactively.",
    "mars_cpg_example": "IoT sensors and ML models that predict when factory machinery needs maintenance, reducing unexpected downtime.",
    "mars_wrigley_example": "Predicting failure of a M&M's color sorter using vibration data."
  },
  {
    "id": 118,
    "label": "Knowledge Management",
    "shortLabel": "Knowledge Mgmt",
    "level": 2,
    "category": "Use Cases",
    "definition": "Systems that organize, index, retrieve, and summarize institutional knowledge for search and decision support.",
    "mars_cpg_example": "Internal search engine powered by LLMs that helps employees find information across millions of documents.",
    "mars_wrigley_example": "An LLM portal to search Mars Wrigley SOPs and brand books."
  },
  {
    "id": 119,
    "label": "Document Search & Retrieval",
    "shortLabel": "Document Search",
    "level": 3,
    "category": "Use Cases",
    "definition": "Semantic and keyword search over documents using embeddings, retrieval systems, and hybrid ranking.",
    "mars_cpg_example": "RAG-powered system that allows R&D teams to ask questions and get answers from decades of research documents.",
    "mars_wrigley_example": "Sales asks: 'What are Orbit display specs for Tesco?' and gets the exact page."
  },
  {
    "id": 120,
    "label": "Automated Summarization",
    "shortLabel": "AI Summarizer",
    "level": 3,
    "category": "Use Cases",
    "definition": "Generating concise summaries of long documents, meetings, or reports using abstractive or extractive methods.",
    "mars_cpg_example": "LLM that summarizes lengthy market research reports into executive briefings.",
    "mars_wrigley_example": "Summarizing a 60-page Snickers MMM report into a 1-page brief."
  },
  {
    "id": 121,
    "label": "Chatbots & Virtual Assistants",
    "shortLabel": "Chatbots & VAs",
    "level": 2,
    "category": "Use Cases",
    "definition": "Conversational systems that answer questions, automate tasks, and assist users via dialogue interfaces.",
    "mars_cpg_example": "Customer service chatbot that answers product questions and helps resolve issues 24/7.",
    "mars_wrigley_example": "A consumer chatbot answering allergen questions for Skittles."
  },
  {
    "id": 122,
    "label": "Customer Service Automation",
    "shortLabel": "CSA",
    "level": 3,
    "category": "Use Cases",
    "definition": "Using chatbots, routing, and automated workflows to handle common customer interactions and reduce agent load.",
    "mars_cpg_example": "Chatbot that handles 80% of routine customer questions, escalating complex issues to human agents.",
    "mars_wrigley_example": "Bot resolves common 'Twix caramel too hard' inquiries with troubleshooting steps."
  },
  {
    "id": 123,
    "label": "Employee Support Assistant",
    "shortLabel": "Support Assistant",
    "level": 3,
    "category": "Use Cases",
    "definition": "Internal assistants that help employees with HR, IT, onboarding, and operational queries.",
    "mars_cpg_example": "Internal chatbot that helps employees with HR policy questions, IT troubleshooting, and benefits information.",
    "mars_wrigley_example": "HR assistant answers benefits questions for Mars Wrigley plant staff."
  },
  {
    "id": 124,
    "label": "Product Innovation",
    "shortLabel": "Product Innovation",
    "level": 2,
    "category": "Use Cases",
    "definition": "Using AI to accelerate ideation, prototyping, formulation, and testing of new products and features.",
    "mars_cpg_example": "AI systems that analyze market trends, predict flavor preferences, and suggest new product concepts.",
    "mars_wrigley_example": "Model proposes a new Maltesers flavor concept based on social trends."
  },
  {
    "id": 125,
    "label": "Flavor & Recipe Optimization",
    "shortLabel": "Flavor Optimization",
    "level": 3,
    "category": "Use Cases",
    "definition": "Applying models and optimization methods to formulate and tune recipes and sensory profiles.",
    "mars_cpg_example": "ML models that predict consumer preference for new flavor combinations based on ingredient profiles and market data.",
    "mars_wrigley_example": "Using Bayesian optimization to tune Twix caramel viscosity and bake time so bars deliver the target chew across humid climates in Southeast Asia."
  },
  {
    "id": 126,
    "label": "Trend Analysis",
    "shortLabel": "Trend Analysis",
    "level": 3,
    "category": "Use Cases",
    "definition": "Detecting emerging topics, market shifts, and consumer preferences using time-series and text analysis.",
    "mars_cpg_example": "NLP system analyzing social media, search trends, and review data to identify emerging flavor and packaging trends.",
    "mars_wrigley_example": "NLP monitors TikTok and Instagram to detect spikes in freeze-dried Skittles and protein chocolate chatter, feeding the Mars Wrigley innovation pipeline."
  },
  {
    "id": 127,
    "label": "Process Automation",
    "shortLabel": "Process Automation",
    "level": 2,
    "category": "Use Cases",
    "definition": "Automating repetitive business tasks and workflows using RPA, document understanding, and intelligent orchestration.",
    "mars_cpg_example": "AI agents that automatically process invoices, generate reports, and update systems without human intervention.",
    "mars_wrigley_example": "RPA bots and LLMs reconcile retailer trade-claim PDFs for a Snickers BOGO promotion and post accruals in SAP automatically."
  },
  {
    "id": 128,
    "label": "Data Entry & Processing",
    "shortLabel": "Data Entry",
    "level": 3,
    "category": "Use Cases",
    "definition": "Automating capture, extraction, validation, and routing of structured and unstructured data.",
    "mars_cpg_example": "OCR and NLP system that automatically extracts data from supplier invoices and enters it into the ERP system.",
    "mars_wrigley_example": "An OCR pipeline extracts batch IDs and moisture percentage from gum base supplier COAs for Extra, validates them, and loads the data into the LIMS and ERP."
  },
  {
    "id": 129,
    "label": "Report Generation",
    "shortLabel": "Report Generation",
    "level": 3,
    "category": "Use Cases",
    "definition": "Automating creation of analyses, dashboards, and written reports from model outputs and data sources.",
    "mars_cpg_example": "AI system that automatically generates weekly sales reports with insights and anomaly detection.",
    "mars_wrigley_example": "An agent auto-builds the weekly Gum and Mints sell-through deck for Orbit and Extra, pulling POS data, charts, and plain-language commentary."
  },
  {
    "id": 130,
    "label": "Deep Learning",
    "shortLabel": "Deep Learning",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "A subset of machine learning that uses multi-layer neural networks (deep architectures) to learn hierarchical feature representations from data.",
    "mars_cpg_example": "Using deep learning models to forecast confectionery sales by analyzing historical sales, weather, and holiday data.",
    "mars_wrigley_example": "A deep learning model forecasts Halloween multipack demand for M&M's by ZIP code using weather, school calendars, and retailer events."
  },
  {
    "id": 131,
    "label": "Transfer Learning",
    "shortLabel": "Transfer Learning",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Reusing knowledge from pretrained models to accelerate learning on related tasks with less data and compute.",
    "mars_cpg_example": "Reusing a model trained on global consumer sentiment data to predict local brand preferences.",
    "mars_wrigley_example": "Fine-tune a pretrained vision model to recognize Twix, Snickers, and Skittles facings in shelf photos for retail audits."
  },
  {
    "id": 132,
    "label": "Activation Function",
    "shortLabel": "Activation Function",
    "level": 4,
    "category": "Foundational Concepts",
    "definition": "Non-linear functions applied to neuron outputs introducing non-linearity into neural networks (ReLU, sigmoid, tanh, GELU).",
    "mars_cpg_example": "Using ReLU activation to speed up training in product demand prediction models.",
    "mars_wrigley_example": "Using GELU activations in a transformer-based demand model for seasonal Celebrations packs improved convergence and reduced MAE."
  },
  {
    "id": 133,
    "label": "Multi-Layer Perceptron (MLP)",
    "shortLabel": "MLP",
    "level": 4,
    "category": "Models & Architectures",
    "definition": "Fully connected feedforward neural network used as a building block in many architectures.",
    "mars_cpg_example": "Using an MLP for classifying customer feedback into categories such as taste, packaging, or price.",
    "mars_wrigley_example": "An MLP classifies Altoids reviews into flavor intensity, tin durability, and price topics to route insights to R&D and packaging."
  },
  {
    "id": 134,
    "label": "Back Propagation",
    "shortLabel": "Back Propagation",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "Gradient-based algorithm for computing parameter gradients by propagating errors backward through network layers; used to train neural networks.",
    "mars_cpg_example": "Training a forecasting model by minimizing prediction errors through backpropagation.",
    "mars_wrigley_example": "Backpropagation trains a vision model to detect micro-tears in Snickers wrappers on high-speed lines using annotated camera frames."
  },
  {
    "id": 135,
    "label": "Decision Tree",
    "shortLabel": "Decision Tree",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "A tree-structured predictive model that splits input space based on feature thresholds to produce interpretable rules.",
    "mars_cpg_example": "A flowchart-like system that helps figure out what most affects sales - like weather or holiday timing.",
    "mars_wrigley_example": "A decision tree selects which convenience stores should get Wrigley's Spearmint clip-strips based on traffic, coffee adjacency, and historical uplift."
  },
  {
    "id": 136,
    "label": "Clustering",
    "shortLabel": "Clustering",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "Unsupervised grouping methods (k-means, hierarchical, DBSCAN) that partition data into clusters of similar items.",
    "mars_cpg_example": "Identifying natural customer segments for targeted promotions using clustering.",
    "mars_wrigley_example": "k-means clusters independent grocers by gum and mints velocity and flavor mix to tailor assortments of Extra, Doublemint, and Altoids."
  },
  {
    "id": 137,
    "label": "Support Vector Machines (SVM)",
    "shortLabel": "SVM",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "A supervised algorithm that finds maximum-margin hyperplanes to separate classes in feature space (with kernelized variants).",
    "mars_cpg_example": "Classifying product reviews as positive or negative using an SVM model.",
    "mars_wrigley_example": "An SVM classifies tweets about Peanut M&M's as positive, neutral, or negative to prioritize community management responses."
  },
  {
    "id": 138,
    "label": "Regression Analysis",
    "shortLabel": "Regression Analysis",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "Techniques for modeling relationships between variables, including linear and non-linear regression used for prediction and inference.",
    "mars_cpg_example": "Seeing how much more people buy when you spend more on ads.",
    "mars_wrigley_example": "Regression analysis quantifies price elasticity for Snickers singles versus duo bars by channel to guide promotion depth."
  },
  {
    "id": 139,
    "label": "Natural Language Processing (NLP)",
    "shortLabel": "NLP",
    "level": 2,
    "category": "Foundational Concepts",
    "definition": "Field focused on computational methods for analyzing and generating natural language text and speech.",
    "mars_cpg_example": "Analyzing customer feedback and social media posts to extract emerging trends using NLP.",
    "mars_wrigley_example": "NLP mines call-center and social comments to detect Galaxy too sweet versus melts fast themes by market for formulation tweaks."
  },
  {
    "id": 140,
    "label": "Language Modeling",
    "shortLabel": "Language Modeling",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Training models to estimate probability distributions over sequences of words or tokens; foundational for many NLP tasks.",
    "mars_cpg_example": "Training a model to automatically write marketing slogans based on brand voice examples.",
    "mars_wrigley_example": "A fine-tuned language model writes playful Hubba Bubba copy variants that match US and UK brand tone while respecting guardrails."
  },
  {
    "id": 141,
    "label": "Computer Vision",
    "shortLabel": "Computer Vision",
    "level": 2,
    "category": "Foundational Concepts",
    "definition": "Field focused on processing and interpreting images and videos to extract information and enable perception.",
    "mars_cpg_example": "Detecting packaging defects in production lines using computer vision systems.",
    "mars_wrigley_example": "Computer vision detects misprints and color drift on Skittles rainbow packs in real time on the packaging line."
  },
  {
    "id": 142,
    "label": "Robotics",
    "shortLabel": "Robotics",
    "level": 2,
    "category": "Foundational Concepts",
    "definition": "Interdisciplinary field combining perception, planning, control, and embodied AI to design autonomous physical systems.",
    "mars_cpg_example": "Deploying AI-powered robots in Mars warehouses to automate packaging and logistics.",
    "mars_wrigley_example": "AI-guided robots pick and place Maltesers into Celebrations assortments while adjusting to line speed and minor misalignments."
  },
  {
    "id": 143,
    "label": "Semantic Modeling",
    "shortLabel": "Semantic Modeling",
    "level": 2,
    "category": "Foundational Concepts",
    "definition": "The process of structuring and encoding concepts, relationships, and rules so machines can interpret, reason, and derive meaning from data.",
    "mars_cpg_example": "Using ontologies to represent relationships between ingredients, suppliers, and brands in Mars' product knowledge graph.",
    "mars_wrigley_example": "A Mars Wrigley ingredient ontology links cocoa origin to roasting profile to SKU to support traceability and formulation queries."
  },
  {
    "id": 144,
    "label": "Automated Reasoning",
    "shortLabel": "Automated Reasoning",
    "level": 2,
    "category": "Foundational Concepts",
    "definition": "Techniques and systems for deriving conclusions from formal knowledge using logic, constraint solving, and theorem proving.",
    "mars_cpg_example": "Building systems that automatically reason about compliance rules and safety standards in manufacturing.",
    "mars_wrigley_example": "A rules engine verifies EU allergen statements and minimum font sizes for a new Bounty wrapper before artwork release."
  },
  {
    "id": 145,
    "label": "Classification",
    "shortLabel": "Classification",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "Supervised prediction tasks that assign discrete labels to inputs; implemented using many algorithm families (trees, SVMs, neural nets).",
    "mars_cpg_example": "Categorizing customer complaints into types like 'product quality', 'delivery', or 'pricing' to route them to the right team.",
    "mars_wrigley_example": "A classifier tags field photos as planogram compliant or not for Twix facings on checkout racks to trigger rep visits."
  },
  {
    "id": 146,
    "label": "Logistic Regression",
    "shortLabel": "Logistic Regression",
    "level": 5,
    "category": "Algorithm & Techniques",
    "definition": "A parametric statistical method for binary or multi-class classification that models the log-odds of class membership.",
    "mars_cpg_example": "Predicting whether a customer will click on an ad based on their browsing history and demographics.",
    "mars_wrigley_example": "Logistic regression predicts the likelihood a shopper adds Extra gum at checkout given basket contents and time of day."
  },
  {
    "id": 147,
    "label": "Random Forest",
    "shortLabel": "Random Forest",
    "level": 5,
    "category": "Algorithm & Techniques",
    "definition": "An ensemble of decision trees using bootstrap aggregation and feature randomness to reduce variance and improve generalization.",
    "mars_cpg_example": "Predicting which products will be bestsellers during holidays by combining insights from hundreds of decision trees.",
    "mars_wrigley_example": "A random forest forecasts uplift for Skittles Zombie Halloween SKUs by store, guiding shipper allocation."
  },
  {
    "id": 148,
    "label": "Gradient Boosting (XGBoost, LightGBM)",
    "shortLabel": "Gradient Boosting",
    "level": 5,
    "category": "Algorithm & Techniques",
    "definition": "Sequential ensemble methods that build strong learners by fitting models to correct errors of prior models (popular high-performance tabular learners).",
    "mars_cpg_example": "Winning approach for demand forecasting competitions; combines many weak predictors into a very accurate model.",
    "mars_wrigley_example": "Gradient-boosted trees predict out-of-stock risk for Snickers at c-stores using POS, deliveries, and local events to trigger replenishment."
  },
  {
    "id": 149,
    "label": "Dimension Reduction",
    "shortLabel": "Dimension Reduction",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "Techniques (linear and non-linear) to reduce feature space dimensionality while preserving structure or variance for visualization or downstream models.",
    "mars_cpg_example": "Simplifying customer data from hundreds of variables down to a few key factors that explain purchasing behavior.",
    "mars_wrigley_example": "Dimensionality reduction compresses 120 sensory attributes across mint gums into a 2D map to compare Orbit and Extra profiles."
  },
  {
    "id": 150,
    "label": "PCA (Principal Component Analysis)",
    "shortLabel": "PCA",
    "level": 5,
    "category": "Algorithm & Techniques",
    "definition": "A linear dimensionality reduction technique that projects data onto orthogonal principal components capturing maximal variance.",
    "mars_cpg_example": "Reducing product attributes from 50 features to 5 main components for easier visualization and analysis.",
    "mars_wrigley_example": "PCA on packaging print sensor data isolates the main drivers of color variance on Galaxy foil, speeding root-cause analysis."
  },
  {
    "id": 151,
    "label": "t-distributed Stochastic Neighbor Embedding",
    "shortLabel": "t-SNE",
    "level": 5,
    "category": "Algorithm & Techniques",
    "definition": "A non-linear visualization method that preserves local structure to project high-dimensional data into 2D/3D for exploration.",
    "mars_cpg_example": "Creating a 2D map showing how different candy products cluster based on ingredients and customer preferences.",
    "mars_wrigley_example": "t-SNE visualizes SKU embeddings to reveal clusters of sour candies like Sour Skittles and Starburst Minis for adjacency planning."
  },
  {
    "id": 152,
    "label": "Anomaly Detection",
    "shortLabel": "Anomaly Detection",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "Identifying unusual or rare patterns using statistical, distance-based, or model-based approaches to flag outliers.",
    "mars_cpg_example": "Automatically flagging unusual spikes or drops in sales that might indicate data errors or real market events.",
    "mars_wrigley_example": "Anomaly detection flags sudden moisture spikes in Skittles coating drums that indicate a dehumidifier failure."
  },
  {
    "id": 153,
    "label": "Rule Learning",
    "shortLabel": "Rule Learning",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "Algorithms that extract human-readable rules or decision lists from data for interpretability and knowledge discovery.",
    "mars_cpg_example": "Finding that customers who buy chocolate bars often also buy coffee, useful for product placement and promotions.",
    "mars_wrigley_example": "Rule learning from basket data finds coffee plus Wrigley's Spearmint affinity, informing cross-merchandising endcaps."
  },
  {
    "id": 154,
    "label": "Energy Based Models",
    "shortLabel": "Energy Based Models",
    "level": 3,
    "category": "Models & Architectures",
    "definition": "Models that define an energy function over configurations and perform learning/inference by assigning low energy to preferred configurations.",
    "mars_cpg_example": "Advanced generative models used in research for creating new product formulations or designs.",
    "mars_wrigley_example": "An energy-based model scores candidate chocolate microstructures to achieve target snap and melt for Galaxy without extra cocoa butter."
  },
  {
    "id": 155,
    "label": "Object Detection",
    "shortLabel": "Object Detection",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Computer vision task and methods for localizing and classifying objects within images or video frames.",
    "mars_cpg_example": "Detecting and counting products on store shelves from photos to monitor stock levels and shelf placement.",
    "mars_wrigley_example": "Object detection counts Snickers and Twix facings in shelf photos to calculate share of shelf versus competitors."
  },
  {
    "id": 156,
    "label": "Image Parsing",
    "shortLabel": "Image Parsing",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "The process of analyzing an image by dividing it into meaningful pixel-level regions so a model can understand objects, boundaries, and structure within a scene.",
    "mars_cpg_example": "Separating the product from the background in packaging photos for quality control analysis.",
    "mars_wrigley_example": "Image Parsing isolates individual M&M's on a conveyor to measure color distribution and reject off-spec pieces."
  },
  {
    "id": 157,
    "label": "Face Recognition",
    "shortLabel": "Face Recognition",
    "level": 3,
    "category": "Use Cases",
    "definition": "Identifying or verifying individuals from facial imagery using feature extraction and matching techniques (note: privacy and ethical issues).",
    "mars_cpg_example": "Analyzing consumer emotions and reactions during product taste tests through facial expression analysis.",
    "mars_wrigley_example": "With consent and on-device processing, face analysis tracks smiles and frowns during Starburst taste tests; no identities are stored."
  },
  {
    "id": 158,
    "label": "Named Entity Recognition (NER)",
    "shortLabel": "NER",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "NLP task to detect and classify spans of text as named entities (people, organizations, locations, etc.).",
    "mars_cpg_example": "Automatically extracting brand names, product names, and competitor mentions from customer reviews and news articles.",
    "mars_wrigley_example": "NER extracts brand, flavor, pack size, retailer, and dates from trade promotion contracts to auto-populate TPM systems."
  },
  {
    "id": 159,
    "label": "Machine Translation",
    "shortLabel": "Machine Translation",
    "level": 3,
    "category": "Use Cases",
    "definition": "Automatically translating text or speech between languages using statistical, neural, or hybrid approaches.",
    "mars_cpg_example": "Translating marketing materials and product descriptions across dozens of languages for global markets.",
    "mars_wrigley_example": "Machine translation localizes Orbit gum packaging claims into Arabic and Thai while preserving regulated phrasing and brand voice."
  },
  {
    "id": 160,
    "label": "Text Classification",
    "shortLabel": "Text Classification",
    "level": 3,
    "category": "Algorithm & Techniques",
    "definition": "Assigning predefined categories or labels to text documents using supervised or transfer-learning techniques.",
    "mars_cpg_example": "Automatically routing customer emails to the appropriate department based on their content and intent.",
    "mars_wrigley_example": "Text classification routes inbound Skittles messages into flavor request, quality issue, or contest question queues."
  },
  {
    "id": 161,
    "label": "Batch Normalization",
    "shortLabel": "Batch Normalization",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "Layer-level normalization applied during training to stabilize and speed up convergence across mini-batches.",
    "mars_cpg_example": "Speeding up the training of deep learning models used for image recognition in quality control.",
    "mars_wrigley_example": "Batch normalization stabilizes training of a CNN that inspects Twix bar alignment and spacing on the production line."
  },
  {
    "id": 162,
    "label": "Dropout",
    "shortLabel": "Dropout",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "A stochastic regularization technique that temporally removes a subset of neurons during training to reduce overfitting.",
    "mars_cpg_example": "Ensuring demand forecasting models generalize well to new markets and don't just memorize historical data.",
    "mars_wrigley_example": "Dropout prevents overfitting in a regional demand model for Altoids where historical data is sparse."
  },
  {
    "id": 163,
    "label": "Regularization",
    "shortLabel": "Regularization",
    "level": 4,
    "category": "Algorithm & Techniques",
    "definition": "A set of strategies (L1/L2 penalties, dropout, early stopping) to constrain model complexity and improve generalization.",
    "mars_cpg_example": "Preventing a sales prediction model from becoming too complex and fitting noise rather than true patterns.",
    "mars_wrigley_example": "L2 regularization keeps a price-optimization model for M&M's from overreacting to short-term promo noise."
  },
  {
    "id": 164,
    "label": "Loss Functions",
    "shortLabel": "Loss Functions",
    "level": 4,
    "category": "Foundational Concepts",
    "definition": "Objective functions that quantify prediction errors and guide optimization (cross-entropy, MSE, hinge loss, etc.).",
    "mars_cpg_example": "Choosing the right loss function to ensure a demand forecasting model penalizes large errors more heavily.",
    "mars_wrigley_example": "Using focal loss helps a defect detector learn rare foil tear cases on Galaxy packs without being overwhelmed by normal examples."
  },
  {
    "id": 165,
    "label": "Gradient Descent",
    "shortLabel": "Gradient Descent",
    "level": 5,
    "category": "Algorithm & Techniques",
    "definition": "Iterative optimization algorithm that updates parameters in the direction of negative gradients to minimize the loss function (SGD, Adam variants).",
    "mars_cpg_example": "The core algorithm that trains neural networks by gradually improving predictions through small parameter updates.",
    "mars_wrigley_example": "Gradient descent trains a recommender that picks the best variety shippers per store for seasonal resets across Mars Wrigley brands."
  },
  {
    "id": 167,
    "label": "Trade Promotion & Retail",
    "shortLabel": "Trade Promo & Retail",
    "level": 2,
    "category": "Use Cases",
    "definition": "AI-driven optimization of trade promotions, retail execution, and promotional effectiveness across channels and retailers.",
    "mars_cpg_example": "Predicting which promotional tactics will drive the highest ROI for each retailer and optimizing trade spend allocation across regions.",
    "mars_wrigley_example": "Optimization recommends retailer-specific offers for M&M's sharing bags versus Snickers singles to maximize ROI by store cluster."
  },
  {
    "id": 168,
    "label": "Media Mix & Marketing Optimization",
    "shortLabel": "MMM",
    "level": 2,
    "category": "Use Cases",
    "definition": "Using AI to optimize marketing spend allocation across channels, measure campaign effectiveness, and maximize marketing ROI.",
    "mars_cpg_example": "Building models that attribute sales lift to different marketing channels (TV, digital, social) and recommend optimal budget allocation for maximum impact.",
    "mars_wrigley_example": "Media mix modeling reallocates budget toward TikTok for Skittles Pride, trimming TV by 10 percent while holding sales lift."
  },
  {
    "id": 169,
    "label": "Competitive Intelligence",
    "shortLabel": "Competitive Intelligence",
    "level": 2,
    "category": "Use Cases",
    "definition": "Leveraging AI to monitor competitors, analyze market positioning, track pricing strategies, and identify competitive threats and opportunities.",
    "mars_cpg_example": "Automatically tracking competitor product launches, pricing changes, and promotional activities across markets to inform strategic decisions.",
    "mars_wrigley_example": "Automated trackers compare Hershey and Nestle promo cadence and pricing against Snickers and Twix to inform counter-moves."
  },
  {
    "id": 170,
    "label": "Shopper Marketing & In-Store",
    "shortLabel": "Shopper Marketing",
    "level": 2,
    "category": "Use Cases",
    "definition": "AI applications for optimizing in-store experiences, shelf placement, planogram compliance, and point-of-sale activation.",
    "mars_cpg_example": "Using computer vision to analyze shelf share, detect out-of-stock situations, and optimize product placement based on shopper behavior patterns.",
    "mars_wrigley_example": "Computer vision verifies Extra and Doublemint placement on impulse racks and alerts reps when slots are empty or mislabeled."
  }
]